import { ExternalLink } from "lucide-react"
import { UIC_SUSTAINABILITY_LINKS } from "./uic-sustainability-links"

export default function UicSustainabilityFooterLinks() {
  const topicLinks = UIC_SUSTAINABILITY_LINKS.filter((link) => !link.highlight)
  const highlightLink = UIC_SUSTAINABILITY_LINKS.find((link) => link.highlight)

  return (
    <nav
      aria-label="UIC Sustainability on uic.org"
      className="p-4 w-full max-w-sm text-center md:text-left"
    >
      <h4 className="text-lg font-bold">UIC Sustainability</h4>
      <p className="text-xs text-muted-foreground mt-1 mb-3">
        Explore our activities on uic.org
      </p>
      <ul className="space-y-1.5 text-sm">
        {topicLinks.map((link) => (
          <li key={link.href}>
            <a
              href={link.href}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-1 text-muted-foreground hover:text-foreground underline-offset-4 hover:underline transition-colors"
            >
              {link.label}
              <ExternalLink
                className="size-3 shrink-0 opacity-60"
                aria-hidden="true"
              />
            </a>
          </li>
        ))}
        {highlightLink ? (
          <li className="pt-2 mt-2 border-t border-slate-500/15">
            <a
              href={highlightLink.href}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-1 font-medium text-green-700 dark:text-green-400 hover:underline underline-offset-4 transition-colors"
            >
              {highlightLink.label}
              <ExternalLink
                className="size-3 shrink-0 opacity-70"
                aria-hidden="true"
              />
            </a>
          </li>
        ) : null}
      </ul>
    </nav>
  )
}
